/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import "./services.css";
import { useStateValue } from "../../../StateProvider";
import { Button, Icon, Image, Item, Label } from "semantic-ui-react";
const Services = ({ name, location, description, id ,step,setLastSetp}) => {
  const [{}, dispatch] = useStateValue();

 

  const userSelectService = () => {
    dispatch({
      type: "ADD_USER_SELECTED_SERVICE",
      data: {
        name,
        id,
      },
    });

    let newstep= step + 1
    setLastSetp(newstep);

  };

  return (
    <Item style={{ maxWidth: "80%" }}>
      <Item.Image src={require("./../../../images/hero-image-app.jpg")} />
      <Item.Content>
        <Item.Header as="a">{name}</Item.Header>
        <Item.Meta>
          <span className="cinema">{location}</span>
        </Item.Meta>
        <Item.Description>{description}.</Item.Description>
        <Item.Extra>
          <Button
            primary
            floated="right"
            className="reserve-btn"
            onClick={userSelectService}
          >
            Reserve
            <Icon name="right chevron" />
          </Button>
        </Item.Extra>
      </Item.Content>
    </Item>
  );
};

export default Services;
